<template>
  <div>
    <BuilderBar />
    <router-view></router-view>
  </div>
</template>

<script>
import BuilderBar from "@/components/navigation-bar/BuilderBar";
export default {
  components: {
    BuilderBar,
  },
};
</script>
